/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerAddFeaturesMutationRequest,
  TelegramProductsModeratorControllerAddFeaturesMutationResponse,
  TelegramProductsModeratorControllerAddFeaturesPathParams,
  TelegramProductsModeratorControllerAddFeatures401,
  TelegramProductsModeratorControllerAddFeatures404,
} from '../types/TelegramProductsModeratorControllerAddFeatures.ts';

function getTelegramProductsModeratorAddFeaturesUrl(
  id: TelegramProductsModeratorControllerAddFeaturesPathParams['id'],
) {
  const res = { method: 'POST', url: `/api/moderator/telegram/products/features/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/features/:id}
 */
export async function telegramProductsModeratorAddFeatures(
  id: TelegramProductsModeratorControllerAddFeaturesPathParams['id'],
  data: TelegramProductsModeratorControllerAddFeaturesMutationRequest,
  config: Partial<RequestConfig<TelegramProductsModeratorControllerAddFeaturesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsModeratorControllerAddFeaturesMutationResponse,
    ResponseErrorConfig<
      TelegramProductsModeratorControllerAddFeatures401 | TelegramProductsModeratorControllerAddFeatures404
    >,
    TelegramProductsModeratorControllerAddFeaturesMutationRequest
  >({
    method: 'POST',
    url: getTelegramProductsModeratorAddFeaturesUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
